import React, { useEffect } from "react";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import client from "api/WookAxios";
import ModalContext from "components/contexts/ModalContext";
import MenuContext from "header/MenuContext";
import UserContext from "user/UserContext";
import snu from "images/snu_white.png";
import menu from "images/menu.png";
import { BsPersonFill } from "react-icons/bs";
// import { BsPersonHeart } from 'react-icons/bs';
import log from "loglevel";
import { AUTH_STATUS } from "constants/auth";
import { toast } from "sonner";

const MenuFrame = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  // background: red;
  box-sizing: border-box;

  @media (max-width: 1024px) {
    width: 100%;
    justify-content: space-between;
    padding: 0px 20px;
  }
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  width: 25px;
  padding-bottom: 1px;
  cursor: pointer;

  @media (min-width: 768px) and (max-width: 1024px) {
    width: 27px;
  }

  @media (max-width: 768px) {
    width: 33px;
  }
`;

const MenuList = styled.div`
  display: flex;
  padding-left: 40px;

  @media (max-width: 1024px) {
    position: fixed;
    background: #323332;
    opacity: 0.9;
    top: 53px;
    right: 2px;
    display: ${(props) => (props.$visible ? "flex" : "none")};
    flex-direction: column;
    padding: 10px 0px;
  }
`;

const MenuItem = styled.div`
  color: #d6d6d7;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 15px;
  font-weight: 400;
  text-align: center;
  cursor: pointer;
  // padding: 20px 30px;
  padding: ${(props) => (props.$pc ? "10px 20px" : "20px 30px")};

  @media (max-width: 1024px) {
    padding: 15px 30px;
    font-size: 25px;

    & + & {
      border-top: 1px outset rgb(0, 0, 0, 0.5);
    }
  }
`;

const MenuIcon = styled.div`
  display: none;
  align-items: center;
  width: 25px;
  cursor: pointer;

  @media (min-width: 768px) and (max-width: 1024px) {
    display: flex;
    width: 30px;
  }

  @media (max-width: 768px) {
    display: flex;
    align-items; center;
    width: 36px;
  }
`;

const RightMenus = styled.div`
  display: flex;
  justify-content: right;
  align-items: center;
  // width: 170px;
  // background: green;

  @media (max-width: 1024px) {
    display: flex;
  }
`;

const StyledUser = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 25px;
  padding-right: 20px;
  padding-left: 20px;
  color: #d6d6d7;
  cursor: pointer;
  // background: blue;

  @media (min-width: 768px) and (max-width: 1024px) {
    height: 30px;
  }

  @media (max-width: 768px) {
    height: 36px;
  }
`;

const StyledName = styled.div`
  font-size: 16px;
  cursor: pointer;
  font-family: "Roboto-Regular", Helvetica;
  // display: flex;
  // align-items: center;
  // vertical-align: middle;
  // line-height: 2px;
  // background: blue;
  padding-right: 5px;

  @media (min-width: 768px) and (max-width: 1024px) {
    font-size: 20px;
  }

  @media (max-width: 768px) {
    font-size: 26px;
  }
`;

const StyledUserImg = styled.div`
  height: 100%;
  cursor: pointer;
  // color: pink;
  // background: blue;
  width: 25px;

  @media (min-width: 768px) and (max-width: 1024px) {
    // font-size: 30px;
    width: 33px;
  }

  @media (max-width: 768px) {
    // font-size: 36px;
    width: 36px;
  }
`;

const UserMenu = styled.div`
  display: ${(props) => (props.$visible ? "flex" : "none")};
  position: fixed;
  background: #323332;
  opacity: 0.9;
  top: 41px;
  flex-direction: column;

  @media (max-width: 1024px) {
    top: 51px;
    // right: 50px;
  }
`;

const Menu = () => {
  const { modalActions } = useContext(ModalContext);
  const { menuState, menuActions } = useContext(MenuContext);
  // const { userState, userActions } = useContext(UserContext);
  const { user, setUser, setAuthStatus } = useContext(UserContext);
  const menuListRef = React.useRef(null);
  const menuListButtonRef = React.useRef(null);
  const userMenuRef = React.useRef(null);
  const userMenuButtonRef = React.useRef(null);
  
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutsideMenulist = e => {
      if (
        menuListRef.current && !menuListRef.current.contains(e.target) &&
        menuListButtonRef.current && !menuListButtonRef.current.contains(e.target)
      ) {
        menuActions.setMenuListVisible(false);
      }
    };

    const handleClickOutsideUserMenu = e => {
      if (
        userMenuRef.current && !userMenuRef.current.contains(e.target) &&
        userMenuButtonRef.current && !userMenuButtonRef.current.contains(e.target)
      ) {
        menuActions.setUserMenuVisible(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutsideMenulist);
    document.addEventListener('mousedown', handleClickOutsideUserMenu);

    // cleanup
    return () => {
      document.removeEventListener('mousedown', handleClickOutsideMenulist);
      document.removeEventListener('mousedown', handleClickOutsideUserMenu);
    };
  }, [menuActions]);

  const navigateHome = () => {
    navigate("/");
  };

  const handleNotice = () => {
    menuActions.setMenuListVisible(false);
    navigate("/notice");
  };

  const handleBoard = () => {
    menuActions.setMenuListVisible(false);
    navigate("/postlist");
  };

  const handleMap = () => {
    menuActions.setMenuListVisible(false);
    navigate("/map");
  };

  const handleSponsor = () => {
    menuActions.setMenuListVisible(false);
    navigate('/sponsor');
  };

  const handleRegisterCheck = () => {
    menuActions.setMenuListVisible(false);
    modalActions.setRegisterCheckVisible(true);
  };

  const handleConsent = () => {
    menuActions.setMenuListVisible(false);
    modalActions.setConsentVisible(true);
  };

  const handleRegister = () => {
    menuActions.setMenuListVisible(false);
    navigate('/register');
  };

  const handleLogin = () => {
    menuActions.setMenuListVisible(false);
    modalActions.openLogin();
  };

  const handleLogout = async () => {
    menuActions.setMenuListVisible(false);
    menuActions.setUserMenuVisible(false);

    try {
      const response = await client.logout();
      log.debug('LOGOUT_SUCCESS', response);
      toast.success('정상적으로 로그아웃 되었습니다.');
    } catch (e) {
        log.debug('LOGOUT_FAILED', e.response);
    } finally {
      window.__skipProtectedMsg = true;
      setAuthStatus(AUTH_STATUS.UNAUTHENTICATED);
      setUser(null);
    }
  };

  const handleUser = () => {
    if (user) {
      menuActions.setUserMenuVisible(!menuState.userMenuVisible);
    } else {
      modalActions.openLogin();
    }
  };

  const handleMenulist = () => {
    menuActions.setMenuListVisible(!menuState.menuListVisible);
  };

  const handleMyPage = () => {
    menuActions.setMenuListVisible(false);
    menuActions.setUserMenuVisible(false);
    navigate('/mypage')
  };

  const handleLaunching = () => {
    navigate("/launching");
    menuActions.setMenuListVisible(false);
  };

  return (
    <MenuFrame>
      <Logo onClick={navigateHome}>
        <img src={snu} alt="snu-image" width="100%" />
      </Logo>
      {/* <MenuList $visible={menuState.menuListVisible}> */}
      {/* <MenuList $visible={menuState.menuListVisible}> */}
      <MenuList $visible={menuState.menuListVisible} ref={menuListRef}>
        <MenuItem onClick={handleNotice}>공지사항</MenuItem>
        <MenuItem onClick={handleBoard}>게시판</MenuItem>
        <MenuItem onClick={handleMap}>개원지도</MenuItem>
        <MenuItem onClick={handleSponsor}>동기후원</MenuItem>
        {user ? (
          <>
            <MenuItem onClick={handleMyPage}>마이페이지</MenuItem>
            <MenuItem onClick={handleLogout}>로그아웃</MenuItem>
          </>
        ) : (
          <>
            <MenuItem onClick={handleRegister}>회원가입</MenuItem>
            <MenuItem onClick={handleLogin}>로그인</MenuItem>
          </>
        )}
      </MenuList>

      <RightMenus>
        <StyledUser onClick={handleUser} ref={userMenuButtonRef}>
          <StyledName>{user ? user.name : ''}</StyledName>
          <StyledUserImg>
            {user ? (
              <BsPersonFill size="100%" color="pink" />
            ) : (
              <BsPersonFill size="100%" />
            )}
          </StyledUserImg>
        </StyledUser>

        <UserMenu $visible={menuState.userMenuVisible} ref={userMenuRef}>
          <MenuItem onClick={handleMyPage} $pc={true}>
            마이페이지
          </MenuItem>
          <MenuItem onClick={handleLogout} $pc={true}>
            로그아웃
          </MenuItem>
        </UserMenu>

        <MenuIcon onClick={handleMenulist} ref={menuListButtonRef}>
          <img src={menu} alt="menu-image" width="100%" />
        </MenuIcon>
      </RightMenus>
    </MenuFrame>
  );
};

export default Menu;
